<div class="modal fade" id="errorModal" tabindex="-1" aria-labelledby="errorModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header" [ngClass]="alertClass">
                <h5 class="modal-title" id="errorModalLabel">
                    <i class="bi" [ngClass]="iconClass"></i>
                    {{ modalConfig.title }}
                </h5>
                <button type="button" class="btn-close" (click)="onClose()" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <p class="mb-0">{{ modalConfig.message }}</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="onClose()">Close</button>
            </div>
        </div>
    </div>
</div>

